import React from 'react';
import { remCalc } from '../../../util/style-util';
import checkboxActivePath from 'assets/images/resources/checkbox-active.svg';
import checkboxPath from 'assets/images/resources/checkbox.svg';
import { gray3 } from '../../../styles/style-constants';
import { makeStyles } from '@mui/styles';

type Props =
  | {
      checked: boolean;
      label: string;
      ariaLabel: string;
      onChange: () => any;
    }
  | any;

function CheckBox(props: Props): React.ReactElement {
  const { checkbox, icon, label } = useStyles()();

  function renderBox() {
    return props.checked ? (
      <img alt="-" src={checkboxActivePath} className={icon} />
    ) : (
      <img alt="-" src={checkboxPath} className={icon} />
    );
  }

  return (
    <div
      className={checkbox}
      onClick={props.onChange}
      onKeyPress={props.onChange}
      aria-label={props.ariaLabel}
      role="option"
      aria-checked={props.checked}
      aria-selected={props.checked}
      tabIndex={0}
    >
      {renderBox()}
      <span className={label}>{props.label}</span>
    </div>
  );
}

const useStyles = () =>
  makeStyles(() => ({
    checkbox: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      userSelect: 'none'
    },
    icon: {
      width: 15,
      marginRight: 10,
      cursor: 'pointer'
    },
    label: {
      color: gray3,
      fontSize: remCalc(16),
      fontWeight: 300,
      cursor: 'pointer'
    }
  }));

export default CheckBox;
